export const setSideMenuSelectedItem = (selectedItem) => {
    return {
        type: 'SET_SIDE_MENU_SELECTED_ITEM',
        payload: {
            selectedItem
        }
    }
}

export const updateIsLogin = (isLogin) => {
    return {
        type: 'UPDATE_IS_LOGIN',
        payload: {
            isLogin
        }
    }
}

export const updateProfile = (profile) => {
    return {
        type: 'UPDATE_PROFILE',
        payload: {
            profile
        }
    }
}

export const setToolbarTitle = (title) => {
    return {
        type: 'SET_TOOLBAR_TITLE',
        payload: {
            title
        }
    }
}

